/**
 * DiseaseCategories — мини-справочник «Категории болезней» (AK-232).
 * Тонкий wrapper над `ReferenceMiniCatalog`. DELETE-guard через usage_count.
 */
import { PlatformAdminLayout } from '@/layouts/PlatformAdminLayout';
import { ReferenceMiniCatalog } from '@/components/reference/ReferenceMiniCatalog';
import {
  useCreateDiseaseCategory,
  useDeleteDiseaseCategory,
  useDiseaseCategories,
  useUpdateDiseaseCategory,
} from './hooks/useCatalogQueries';
import { toast } from '@/lib/toast';

function plural(n: number): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m100 >= 11 && m100 <= 14) return 'болезней';
  if (m10 === 1) return 'болезнь';
  if (m10 >= 2 && m10 <= 4) return 'болезни';
  return 'болезней';
}

export function PlatformAdminDiseaseCategoriesPage() {
  const q = useDiseaseCategories();
  const createMut = useCreateDiseaseCategory();
  const updateMut = useUpdateDiseaseCategory();
  const deleteMut = useDeleteDiseaseCategory();

  const items = q.data?.items ?? [];

  return (
    <PlatformAdminLayout>
      <ReferenceMiniCatalog
        title="Категории болезней"
        subtitle={`Мини-справочник · ${items.length} записей`}
        createLabel="Добавить категорию"
        usageBadgeUnit={plural}
        guardMessage="Используется болезнями — нельзя удалить"
        items={items}
        isLoading={q.isLoading}
        onCreate={async (payload) => {
          await createMut.mutateAsync(payload);
          toast.success('Категория создана');
        }}
        onUpdate={async (id, payload) => {
          await updateMut.mutateAsync({ id, payload });
          toast.success('Категория обновлена');
        }}
        onDelete={async (id) => {
          // Отказ ловит и показывает сам ReferenceMiniCatalog (AK-574).
          await deleteMut.mutateAsync(id);
          toast.success('Категория удалена');
        }}
      />
      <p className="mt-3 text-[11px] text-muted-foreground">
        Изменения сразу доступны в select формы болезни. EN-перевод отложен —
        ведём только RU.
      </p>
    </PlatformAdminLayout>
  );
}

export default PlatformAdminDiseaseCategoriesPage;
